import Store from '@/store'

export default [
  {
    path: '/controle',
    name: 'controle-index',
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getPaginateIndustrias')
      next()
    },
    meta: {
      title: 'Controle de Indústrias',
      paginateMethod: 'getPaginateIndustrias',
      paginateAttr: 'paginateIndustrias',
      twoLines: true,
      titleAttr: item => item['nome_fantasia'],
      subtitleAttr: item => item['razao_social'],
      // routeToCreate: 'industrias-create',
      routeToEdit: 'controle-options',
      emptyList: 'Nenhuma indústria foi cadastrada.',
      avatarIcon: 'apartment',
      pageAttr: 'industriaPage',
      pageCommit: 'setIndustriaPage',
      filterAttr: 'industriaFilter',
      filterCommit: 'setIndustriaFilter',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/paginate')
    }
  },
  {
    path: '/controle/:id/selecione',
    name: 'controle-options',
    props: true,
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getIndustria', {
        id: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Controle de Indústrias',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/controle')
    }
  },
  {
    path: '/controle/:id/cadastramento',
    name: 'controle-cadastramento-details',
    props: true,
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getIndustria', {
        id: Number(to.params.id)
      })
      await Store.dispatch('getVinculos', {
        industria: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Cadastramento Inicial - Controle',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/controle/cadastramento/detail')
    }
  },
  {
    path: '/controle/:industria/cadastramento/editar/:id',
    name: 'controle-cadastramento-update',
    props: true,
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getVinculo', {
        id: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Cadastramento Inicial - Controle',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/controle/cadastramento/id')
    }
  },
  {
    path: '/controle/:id/eventos',
    name: 'controle-eventos-details',
    props: true,
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getIndustria', {
        id: Number(to.params.id)
      })
      await Store.dispatch('getEventos', {
        industria: Number(to.params.id),
        periodo: Store.getters.competencia
      })
      next()
    },
    meta: {
      title: 'Eventos Periódicos - Controle',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/controle/eventos/detail')
    }
  },
  {
    path: '/controle/:industria/eventos/editar/:id',
    name: 'controle-eventos-update',
    props: true,
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getEvento', {
        id: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Eventos Periódicos - Controle',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/controle/eventos/id')
    }
  }
]
